<template>
  <div>
    <section class="registerbox " >
      <div class="formHeader" style="height:50px;line-height:50px;background:	#333; border: 1px solid rgb(162, 163, 159);">
        <div style="float:left; padding-top:10px;">
          <h5 class="title is-5" style="color:#fff;padding-left:10px;margin-top:5px"><b>XBHub Closure Details </b></h5>
        </div>
      </div>


     <div class="box">
       <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
         <div class="columns">
             <div class="column">
                <div class="field is-horizontal">
                     <div class="field-label is-normal">
                         <label class="label"> Date :</label>
                     </div>
                     <div class="field-body">
                         <div class="field">
                             <p class="control is-small">
                               <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectedDate'>
                               </v-date-picker>
                             </p>
                         </div>
                     </div>
                 </div>
            </div>
           <div class="column" align="left">
             <button class="button is-info" type="submit" @click="displaydata">Submit</button>
           </div>
           <div class="column" align="left" style="margin-left: -245px;">
              <button class="button is-info" type="submit" @click="downloadCSV">Download COD Closure Report</button>
           </div>
         </div>
       </form>
     </div>
</section>

      <div class="table-responsive registerbox">
          <table class="table table-striped table-bordered" border="1">
              <thead>
                  <tr>
                    <th>Shipping Id</th>
                    <th>SR Name</th>
                    <th>Cod Amount</th>
                    <th>Closure Date</th>

                  </tr>
              </thead>
              <tbody>
                  <tr v-for="value in data">
                    <td> {{ value.shippingid }}</td>
                    <td> {{ value.srname |capitalize }} </td>
                    <td> {{ value.depositeamount }}</td>
                    <td> {{ value.codclosuredate | datechange }}</td>
                  </tr>
              </tbody>
          </table>
      </div>
    </div>
  </template>
<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'codHubClosureReport',
      data: [],
      selectedDate: new Date(),
    }
  },
  computed: {},
  created: function () {
    this.validateUser()
    this.displaydata()
  },
  methods: {
    validateForm(scope) {},
    getDownloadCsvObject: function(result) {
      var csvData = result;
      // console.log('csvData',csvData);
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "CODClosure_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
      var fromdate = (this.selectedDate!=null)?this.formatDate(this.selectedDate):"";
      // console.log('fromdate:',fromdate);
      var xbhubid = this.$route.query.xbhubid;
      var csvObj = {
        fromdate: `${fromdate}`,
        xbhubid:`${xbhubid}`
      };

      this.$http.post(`${CONSTANTS.API_URL}/GetAllCodHubClosureDetails`,csvObj)
        .then(result => {
          // console.log('result.body.returnvalue',result.body.returnvalue);
          if (result.body.returnmsg === 'Successful') {
            this.getDownloadCsvObject(result.body.returnvalue);
            alert("COD closure Report Downloaded Successfully");
          } else {
            alert(result.body.returnmsg);
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },

    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      // console.log();
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      //console.log('keys',keys);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;


      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          //console.log('key:',key);
          ctr++;
        });
        result += lineDelimiter;
        //console.log('result in loop',result);
      });
      console.log('result',result);
      return result;
   },
    displaydata: function () {
      var fromdate = this.formatDate(this.selectedDate);
      var xbhubid = this.$route.query.xbhubid;

      const customerGetobj = {
            fromdate: `${fromdate}`,
            xbhubid: `${xbhubid}`
      }
      // console.log('customerGetobj',customerGetobj);
      this.$http.post(`${CONSTANTS.API_URL}/GetAllCodHubClosureDetails`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            // console.log('result:' , result.body.returnvalue);
            this.data = result.body.returnvalue
          } else {
            alert('No records found')
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    validateUser : function(){

      let ValidateToken = "sKB3uGF0qvklWhTLOgsIXDRJc";
      if (this.$route.query.token === undefined || this.$route.query.token !== ValidateToken) {
          // console.log('session logged done',this.$route.query.token);
          console.log(typeof(this.$route.query.xbhubid));
          localStorage.setItem('userData', '')
          localStorage.setItem('activeTime', '')
          localStorage.setItem('Coduser', '')
          this.$router.push('codSRDayClosure')
      }
    },
    formatDate: function(date) {
        var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
    }
  },
  filters: {
      datechange: function(value) {
       if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
      },
      capitalize: function(value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
  }
}
</script>

<style lang="css">
.table tr th{
  color:#fff!important;
}

.table button{
  background:	#B0C4DE!important;
  color:#000!important;
}
.table tr:hover{
  background:#efefef;
}

tbody tr:nth-child(even) {background: #f2f2f2}
tbody tr:nth-child(odd) {background: #FFF}

.registerbox {
  margin-top:30px;
  margin-left: auto;
  margin-right: auto;
  width: 1159px;
  background-color: #F7F7F7;
}
hr {
  margin-bottom: 0px;
}
</style>
